import { render, staticRenderFns } from "./Scene9.vue?vue&type=template&id=71dc9906&"
import script from "./Scene9.vue?vue&type=script&lang=js&"
export * from "./Scene9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports